import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

import ErrorBoundary from '@/app/ErrorBoundary';
import Sidebar from '@/layouts/components/Sidebar';
import { useDashboardLayout } from '@/hooks/useDashboardLayout.hook';

const DashboardLayout: FC = () => {
  const { user, sections, activePath, sidebarOpen, onToggleSidebar, onCloseSidebar, onLogout } =
    useDashboardLayout();

  return (
    <div className="flex h-screen overflow-hidden bg-[var(--color-surface-muted)]">
      <Sidebar
        sections={sections}
        activePath={activePath}
        user={user}
        isOpen={sidebarOpen}
        onClose={onCloseSidebar}
        onLogout={onLogout}
      />

      <div className="flex h-full min-w-0 flex-1 flex-col overflow-hidden">
        <header className="flex h-[60px] items-center gap-3 border-b border-[var(--color-divider)] bg-white px-4 md:px-7">
          {/* Hamburger — mobile only */}
          <button
            type="button"
            aria-label="Toggle navigation"
            onClick={onToggleSidebar}
            className="flex h-8 w-8 flex-col items-center justify-center gap-[5px] rounded-md text-[var(--color-ink-muted)] transition-colors hover:bg-[var(--color-surface-muted-2)] md:hidden"
          >
            <span className="h-[2px] w-5 rounded-full bg-current" />
            <span className="h-[2px] w-5 rounded-full bg-current" />
            <span className="h-[2px] w-5 rounded-full bg-current" />
          </button>
          <span className="text-sm font-semibold text-[var(--color-ink)]">Shoutt Admin</span>
        </header>

        <main className="flex-1 overflow-y-auto p-4 md:p-7">
          {/* Page-scoped: a crash in one page renders the fallback inside the shell rather
              than replacing the whole panel, so the admin can navigate away. */}
          <ErrorBoundary scope="page">
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
